/* eslint-disable max-statements */
import { RevisionCode } from 'models/revisionCodes';
import moment from 'moment';
import { UiCommands } from './UiCommands';

export async function initializeScreenCommand(this: UiCommands) {
  this.uiState.isScreenLoading = true;
  this.uiState.screenError = null; // reset the error
  this.setUiStateTriggerReRender(this.uiState);
  let revisionCodes: RevisionCode[] = [];
  try {
    revisionCodes = await this.apis.getRevisionCodes();
  } catch (error) {
    this.uiState.isScreenLoading = false;
    this.uiState.screenError = 'Error getting revision codes';
    this.setUiStateTriggerReRender(this.uiState);
    return;
  }

  this.setApiModelState(this.apiModelState);
  this.uiState.isScreenLoading = false;
  this.apiModelState.allRevisionCodes = revisionCodes;
  this.uiState.revisionCodes = revisionCodes.map((revCode) => {
    const { code, startDate, endDate } = revCode;
    const startDateMoment = moment(startDate);
    const endDateMoment = moment(endDate);
    return { code, startDate: startDateMoment, endDate: endDateMoment };
  });

  this.setUiStateTriggerReRender(this.uiState);
}
